import { render, staticRenderFns } from "../../templates/form/milk-inspection-form.pug?vue&type=template&id=3a1ca59e&lang=pug&"
import script from "./MilkInspectionForm.vue?vue&type=script&lang=js&"
export * from "./MilkInspectionForm.vue?vue&type=script&lang=js&"
import style0 from "./MilkInspectionForm.vue?vue&type=style&index=0&id=3a1ca59e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports